import React, { useState, useContext, useEffect } from "react";
import {
  ManageMastersLayout,
  SearchComponent,
  SliderPanel,
} from "../../../components";
import { Button } from "react-bootstrap";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvisorRepresentativeDetailsTile from "./AdvisorRepresentativeTile";
// import { ClearingPartnerDetailsSlider } from "./ClearingPartnerDetailsSlider";
import { useRequest, useDeepEffect } from "../../../abstracts";
import { manageMasterStore } from "../../../contexts";
import {
  getAdvisorOrganisation,
  DeleteClearingPartner,
} from "../../../services";
import { get, isEmpty } from "lodash";
import { AdvisorRepresentativeCreateEditSlider } from "./AdvisorRepCRUContainer";
const AdvisorRepresentativeDetailsContainer = (props) => {
  const { state, dispatch } = useContext(manageMasterStore);
  const [slider, setSlider] = useState(false);
  const [create, setCreate] = useState(false);
  const [editOpen, setIsEdit] = useState(false);

  const [sliderData, setSliderData] = useState({});
  const [advisorRepresentatives, setAdvisorRepresentatives] = useState(
    get(state, "advisors.advisorRepresentatives", [])
  );
  const advisorId = get(state, "advisors.id");
  console.log(
    advisorId,
    get(state, "advisors.advisorRepresentatives", []),
    "state"
  );
  useDeepEffect(() => {
    if (advisorId) {
      getAdvisorOrganisation(advisorId)
        .then((response) => {
          console.log("response", response);
          setAdvisorRepresentatives(
            get(response, "advisor.advisorRepresentatives", [])
          );
        })
        .catch((error) => {});
    }
  }, [editOpen]);
  useDeepEffect(() => {
    if (get(state, "advisors.advisorRepresentatives", [])) {
      setAdvisorRepresentatives(
        get(state, "advisors.advisorRepresentatives", [])
      );
    }
  }, [state]);
  const createPartner = () => {
    setIsEdit(!editOpen);
    setCreate(!create);
    setSliderData({});
  };
  const setEdit = () => {
    setIsEdit(!editOpen);
    setCreate(false);
  };
  const onSearchChange = (val) => {
    const accs = get(state, "advisors.advisorRepresentatives", [])?.filter(
      (e) => e.name.includes(val) || e.number.includes(val)
    );
    setAdvisorRepresentatives(accs);
  };
  console.log("clearingPartnerAccounts", state, advisorRepresentatives);

  // console.log(clearingPartnerAccounts, "clearingPartnerAccounts");
  return (
    <ManageMastersLayout layoutHeader="Manage Advisor Representative">
      <div className="clearing-partner-details-container">
        <SearchComponent
          placeholder="Search by Advisor Representative Name,Number"
          className="search-component-clearing-partner"
          onSearchChange={onSearchChange}
        />
        <div className="header-label">
          <div className="clearing-partner-subjects">
            <div className="clearing-partner-recently-added">
              Recently Added/Modified
            </div>
            <div className="clearing-partner-records">
              {advisorRepresentatives.length} Records found
            </div>
          </div>
          <Button variant="primary" onClick={createPartner}>
            Create Advisor Representative
          </Button>
        </div>
        <div className="clearing-partner-table">
          <div className="header-clearing-partner w-40">
            <div className="table-header-clearing-partner">
              Advisor Representative Name
            </div>
          </div>
          <div className="header-clearing-partner w-20">
            <div className="table-header-clearing-partner">No of Plans</div>
          </div>
          <div className="header-clearing-partner w-30">
            <div className="table-header-clearing-partner">
              Advisor Representative Number
            </div>
          </div>
          <div className="header-clearing-partner w-10">
            <div className="table-header-clearing-partner">Actions</div>
          </div>
        </div>
        <div className="clearing-partner-detail-tiles">
          {advisorRepresentatives?.map((e, i) => {
            return (
              <AdvisorRepresentativeDetailsTile
                setSlider={setSlider}
                data={e}
                advisorId={advisorId}
                setEdit={setEdit}
                setSliderData={setSliderData}
                setAdvisorRepresentatives={setAdvisorRepresentatives}
                key={i}
              />
            );
          })}
        </div>
      </div>

      <SliderPanel
        isOpen={editOpen}
        size={30}
        showCancel={false}
        onClose={setEdit}
        backdropClicked={setEdit}
      >
        <AdvisorRepresentativeCreateEditSlider
          dispatch={dispatch}
          setEdit={setEdit}
          create={create}
          data={sliderData}
          advisorId={advisorId}
        />
      </SliderPanel>
    </ManageMastersLayout>
  );
};

export default AdvisorRepresentativeDetailsContainer;
